(() => {
  const configNode = document.getElementById('MoldeaFeaturesConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const key = 'moldea-favorites-v1';
  const validHandle = h => typeof h === 'string' && h.length > 0 && h.length < 300 && !/[/?#\s\u0000-\u001f]/.test(h);
  const read = () => {
    try { const data = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(data) ? [...new Set(data.filter(validHandle))].slice(0, 100) : []; } catch { return []; }
  };
  let saved = read();
  let revision = 0;
  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true" width="22" height="22"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  const cache = new Map();
  const sync = () => {
    document.querySelectorAll('article').forEach(card => {
      if (card.querySelector('[data-moldea-favorite]')) return;
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      const handle = decodeURIComponent(url.pathname.split('/products/')[1] || '');
      if (!validHandle(handle)) return;
      const button = document.createElement('button'); button.type = 'button'; button.className = 'moldea-heart moldea-heart--card'; button.dataset.moldeaFavorite = handle; button.innerHTML = heart;
      card.classList.add('moldea-wishlist-host'); card.append(button);
    });
    document.querySelectorAll('[data-moldea-favorite]').forEach(button => {
      const active = saved.includes(button.dataset.moldeaFavorite);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? config.labels.remove : config.labels.add);
      const label = button.querySelector('[data-moldea-favorite-label]');
      if (label) { const text = active ? config.labels.remove : config.labels.add; if (label.textContent !== text) label.textContent = text; }
    });
    document.querySelectorAll('[data-moldea-favorites-count]').forEach(node => { if (node.textContent !== String(saved.length)) node.textContent = saved.length; node.hidden = saved.length === 0; });
  };
  const productData = handle => {
    if (!cache.has(handle)) cache.set(handle, fetch(config.root + 'products/' + encodeURIComponent(handle) + '.js').then(r => { if (!r.ok) throw new Error('Unavailable'); return r.json(); }).catch(e => { cache.delete(handle); throw e; }));
    return cache.get(handle);
  };
  const render = async () => {
    const grid = document.querySelector('[data-moldea-favorites-grid]');
    if (!grid) return;
    const status = document.querySelector('[data-moldea-favorites-status]');
    const thisRevision = ++revision;
    grid.replaceChildren();
    status.textContent = saved.length ? config.labels.loading : config.labels.empty;
    const results = await Promise.allSettled(saved.map(productData));
    if (thisRevision !== revision) return;
    let errors = 0;
    results.forEach(result => {
      if (result.status !== 'fulfilled') { errors++; return; }
      const p = result.value;
      const card = document.createElement('article'); card.className = 'moldea-favorite-card';
      const imageLink = document.createElement('a'); imageLink.href = config.root + 'products/' + encodeURIComponent(p.handle);
      if (p.featured_image) {
        const image = document.createElement('img'); image.src = p.featured_image; image.alt = p.title; image.loading = 'lazy'; image.width = 400; image.height = 500; imageLink.append(image);
      }
      const heading = document.createElement('h2');
      const titleLink = document.createElement('a'); titleLink.href = imageLink.href; titleLink.textContent = p.title; heading.append(titleLink);
      const price = document.createElement('p'); price.textContent = new Intl.NumberFormat('es-ES', { style: 'currency', currency: config.currency || 'EUR' }).format(p.price / 100);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'moldea-heart moldea-heart--card'; remove.dataset.moldeaFavorite = p.handle; remove.innerHTML = heart;
      const view = document.createElement('a'); view.className = 'button'; view.href = imageLink.href; view.textContent = config.labels.view;
      card.append(imageLink, remove, heading, price, view); grid.append(card);
    });
    status.textContent = errors ? config.labels.error : saved.length ? '' : config.labels.empty;
    sync();
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-moldea-favorite]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    const handle = button.dataset.moldeaFavorite;
    if (!validHandle(handle)) return;
    const current = read();
    const next = current.includes(handle) ? current.filter(h => h !== handle) : [...current, handle];
    try { localStorage.setItem(key, JSON.stringify(next)); saved = next; } catch { window.alert(config.labels.storage_error); return; }
    sync(); render();
  });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { saved = read(); sync(); render(); } });
  document.addEventListener('shopify:section:load', () => { sync(); render(); });
  new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
  sync(); render();
})();
